import React, { Component } from 'react';
import styled from "styled-components";
import getCookie from '@gerenciatd/next13.utils.common.get-cookie'
import isWebview from '@gerenciatd/next13.utils.common.is-webview';
import TextInfo from '@/bit/components/next13.components.text';
import Button from '@/bit/components/next13.components.button';
import CustomLink from '@/bit/components/next13.components.custom-link';

const MAIN_TAGGING_INFO = {
    componentName: 'OneTrust',
    componentVariation: 'all',
    componentProduct: '',
}

export const addStyle = (css) => {
    let head = document.head || document.getElementsByTagName('head')[0], style = document.createElement('style');
    head.appendChild(style);
    style.appendChild(document.createTextNode(css));
}

const handleOnChangeConsent = ({ detail }) => {
    let ad_storage = 'denied';
    let analytics_storage = 'denied';
    if (detail.indexOf("C0002") !== -1) {
        analytics_storage = 'granted'
    }
    if (detail.indexOf("C0004") !== -1) {
        ad_storage = 'granted'
    }


    gtag('consent', 'update', {
        'ad_storage': ad_storage,
        'analytics_storage': analytics_storage,
    });

}

const initOneTrustListener = (type) => {
    let retries = 100;

    let interval = setInterval(() => {
        const check = document.querySelector('.onetrust-pc-dark-filter');
        if (check) {
            OneTrust.OnConsentChanged(handleOnChangeConsent);
            // cuando asigne el onchange, tengo que aplicar la primera vez
            if (!type) {
                /// accept
                OneTrust.AllowAll();
            }
            if (type && type === 'settings') {
                OneTrust.ToggleInfoDisplay();
            }
            retries = -100;
        } else {
            retries = retries - 1;
        }

        if (retries <= 0) {
            clearInterval(interval)
        }

    }, 100)
}

const generateScriptTag = (properties) => {
    var onetrustScript = document.createElement("script");
    const propertiesKeys = Object.keys(properties);
    propertiesKeys.forEach(key => {
        const value = properties[key];
        onetrustScript.setAttribute(key, value);
    })
    return onetrustScript;
}

export const choosePropertiesDependsOnDomain = () => {
    const { host } = window.location;
    // por defecto movistar y subdominios de .movistar
    let res = {
        src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        type: "text/javascript",
        charset: "UTF-8",
        "data-language": "es",
        "data-domain-script": "12091309-599f-4163-b414-211e6b47f78f",
    };

    if (host.indexOf('.movistaronline.es') > -1) {
        res = {
            src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
            type: "text/javascript",
            charset: "UTF-8",
            "data-language": "es",
            "data-domain-script": "43f3c462-807a-4dd9-92b3-8ab4474263f2",
        }
    }

    if (host.indexOf('.movistarfusion.es') > -1) {
        res = {
            src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
            type: "text/javascript",
            charset: "UTF-8",
            "data-language": "es",
            "data-domain-script": "fbb652b5-c0fb-4551-935f-56fbea0317b2",
        }
    }

    return res;

}

let ONE_TRUST_LOADED = false;
export const loadOneTrustScript = ({ callback, type }) => {
    if (!ONE_TRUST_LOADED) {
        const properties = choosePropertiesDependsOnDomain();
        const onetrustScript = generateScriptTag(properties)
        // onetrustScript.setAttribute("async", "");
        onetrustScript.addEventListener("load", function (event) {
            // una vez que tengo el script tengo que setear el onchage para enterarme de la ventana config
            initOneTrustListener(type)
            if (callback) {
                callback();
            }
        });
        document.body.appendChild(onetrustScript);
    } else {
        try {
            OneTrust.ToggleInfoDisplay();
        } catch (err) {
            console.error(err);
        }
    }
}

export const clickCookies = ({ type, callback, handlerStyles = true }) => {
    const style = type == 'settings' ?
        '.onetrust-pc-dark-filter{display: inherit} #onetrust-banner-sdk{ display: none !important;}' : '.onetrust-pc-dark-filter{display: none !important;}#onetrust-banner-sdk{ display: none !important;}';
    let idBtn = type == 'settings' ? '#onetrust-pc-btn-handler' : '#onetrust-accept-btn-handler';
    if (handlerStyles) {
        addStyle(style);
    }
    loadOneTrustScript({ callback, type })

    setTimeout(() => {
        const elementModal = document.getElementById("onetrust-pc-sdk");
        elementModal.setAttribute("data-cy", "Footer modal cookies");
    }, "500");
};


const StyledOnetrust = styled.div.attrs(props => {
    return ({
        'id': 'cookies-bar-component',
        'data-cy': `${props.cyData || ''}`,
    })
})`
  position:fixed;
  top:0px;
  left:0px;
  width:100vw;
  height: 100%;
  z-index: 49;
  .row {
    margin: 0px;
    padding-bottom: .5rem;
    @media screen and (max-width:768px) {
        padding:.5rem;
        padding-bottom: 1.25rem;
    }
  }
  .text-row {
    padding: 5px 0px;
  }
  .ot-container {
    position: absolute;
    width:100%;
    bottom:0px;
    height: auto;
    z-index: 50;
    background-color:rgba(0,0,0, 0.9);
    .title-gap{
      margin-bottom:0.5rem;
      .text {
        line-height: 120% !important;
      }
    }
    .text-content-gap {
      margin-bottom: 0.5rem;
      .text {
        line-height: 120% !important;
      }
    }
    .button-gap-container{
      display: flex;
      margin:0 auto;
      flex-direction: row;
      max-width: 28.75rem;
      justify-content: flex-end;
      height:100%;
      align-items: center;
      button {
        margin-right: 1rem;
        font-size:1rem;
        padding: .73rem;
        line-height: 1.25rem;
        margin-top: .4rem;
        height: 42px;
      }
      button:last-child{
        margin-right: 0rem;
      }
    }
  }
}

@media screen and (min-width:768px) and (max-width:1000px) {
    .row {
        display: flex;
        flex-direction: column;
        padding:.5rem;
        padding-bottom: 1.25rem;
        gap: 0;
        .btn-container {
            align-self: flex-end;
            justify-content: flex-end;
            display: flex;
          }
          .button-gap-container{
            padding: 0rem;
            justify-content: flex-end;
            flex-direction: row;
            
              button {
                font-size: 1rem;
                height: 42px;
              }
          }

    }
}

@media screen and (max-width:1290px) {
  .fullOpacity .ot-container {
    .button-gap-container{
      flex-direction:column;
      justify-content: center;
      align-items: right;
      button{
          width:100%;
          margin: 0.5rem 0px;
          max-width:15rem;
          font-size:1.025rem;
        }
    }
  }
}


@media screen and (max-width:768px) {
  .btn-container {
    justify-self: flex-end;
  }
  .button-gap-container{
    padding: 0rem;
    justify-content: flex-end;
      button {
        font-size: .875rem !important;
        height: 32px !important;
      }
  }
  .fullOpacity .ot-container {
    padding: 1rem;
    .button-gap-container{
      margin-top:0.5rem;
        button{
          max-width:20rem;
          height:32px;
        }
    }
  }
}


@media screen and (max-width:377px) {
    .btn-container {
        justify-self: normal;
      }
    .button-gap-container{
        padding: 0rem;
        flex-direction: column !important;
        button {
            width: 100% !important;
            font-size: .875rem !important;
            height: 36px;
            margin-right: 0 !important;
          }
      }
  }
`;


class Onetrust extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true
        }
    }

    clickConfig = () => {
        clickCookies({
            type: 'settings',
            callback: () => {
                this.setState({
                    visible: false,
                })
            }
        })
    }
    clickAccept = () => {
        clickCookies({
            type: '',
            callback: () => {
                this.setState({
                    visible: false,
                })
            }
        })
    }

    setVisibility = ({display = 'none' }) => {
      try {
        document.getElementById('cookies-bar-component').style.display = display;
      } catch(e){}
    }

    componentDidMount(){
        // si soy webview hago cosas porque ya para web lo tengo
        const forceShowCookies = window.location.href.indexOf("showCookies") > -1;
        const cookiesAcepted = getCookie("OptanonAlertBoxClosed");
        const isProdEnvironment = `${process.env.NEXT_PUBLIC_ENV_NAME}` === "prod";
        const isDevEnvironment = `${process.env.NEXT_PUBLIC_ENV_NAME}` === "dev";
        if (isWebview() && isProdEnvironment) {
          // analizamos el status
          let retries = 10;
          let waitWB = setInterval(async () => {
            retries--;
            if (window.webviewBridge){
                retries = -1
                const status = await window.webviewBridge.getAttStatus();
                const nullCookieValue = status ===  null;
                // si es nulo y no tenemos cookies aceptadas muestro
                if (nullCookieValue && !cookiesAcepted){
                    this.setVisibility({display: 'block'})
                } else {
                    this.setVisibility({display: 'none'}) 
                }
            }
            if(retries < 0) {
              clearInterval(waitWB);
            }
          },100)
        }
        if (forceShowCookies && !isProdEnvironment) {
            this.setVisibility({display: 'block'})
        }
        if (isDevEnvironment) {
            this.setVisibility({display: 'none'})
        }
    }

    render() {
        const { visible } = this.state;
        if (!visible) {
            return null;
        }
        return (
            <StyledOnetrust className='oneTrustCookie fullOpacity'>
                <div className="ot-container" data-cy="Popup cookies">
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-8 col-sm-7 col-xs-12 text-row'>
                                <div className='title-gap'>
                                    <TextInfo color="white" size="title045" kind="heading" level={2} text="Antes de seguir navegando" cyData="Popup cookies title" />
                                </div>
                                <div className='text-content-gap'>
                                    <TextInfo fontType="light" color="white" size="caption03" text="Movistar utiliza cookies propias y de terceros, así como los datos de la conexión
                      del cliente o usuario para conocer el operador de acceso y, en su caso, asociarlo a su condición de cliente
                      Movistar. Estas cookies serán utilizadas con la finalidad de gestionar y recabar información sobre la
                      utilización del portal, mejorar nuestros servicios y mostrarte publicidad personalizada relacionada con tus
                      preferencias en base a un perfil elaborado a partir de tus hábitos y el análisis de tu comportamiento dentro
                      de la web (por ejemplo, secciones visitadas, consultas realizadas o links visitados). Pulsa 'Aceptar' si
                      autorizas todas estas cookies. También puedes 'Configurar o rechazar las cookies' y consultar la 'Política de
                      cookies', si deseas obtener información detallada sobre cómo Movistar las utiliza, o cómo deshabilitarlas."
                                        cyData="Popup cookies description"
                                    />
                                </div>
                                <CustomLink
                                    href="//www.movistar.es/particulares/centro-de-privacidad?&amp;optionSelected=politica_cookies"
                                    taggingInfo={{
                                        ...MAIN_TAGGING_INFO,
                                        componentContent: 'Más información'
                                    }}
                                    cyData="Popup cookies consultar info"
                                    ariaLabel = "Consultar más información sobre cookies propias y de terceros"
                                >
                                    <TextInfo size="caption03" text="Consultar más información sobre cookies propias y de terceros" color="blue" />
                                </CustomLink>
                            </div>
                            <div className='col-lg-4 col-sm-5 col-xs-12 btn-container'>
                                <div className='button-gap-container'>
                                    <Button
                                        buttonType="primary"
                                        label="Configurar/rechazar cookies"
                                        onClick={this.clickConfig}
                                        taggingInfo={{
                                            ...MAIN_TAGGING_INFO,
                                            componentContent: 'Configurar/rechazar cookies'
                                        }}
                                        cyData="Popup cookies configurar/rechazar"
                                    />
                                    <Button
                                        buttonType="primary"
                                        label="Aceptar cookies"
                                        onClick={this.clickAccept}
                                        taggingInfo={{
                                            ...MAIN_TAGGING_INFO,
                                            componentContent: 'Aceptar cookies'
                                        }}
                                        cyData="Popup cookies aceptar"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </StyledOnetrust>
        );
    }
}


export default Onetrust;